import Collapse from "antd/lib/collapse"
import Row from "antd/lib/row"
import React, { useState } from "react"
import { FormCategoryEnum, FormMinMaxInterface } from "./form.types"
import FormInputElem from "./formInputElem"

export const FormMinMax = ({ header, inputType, normalize, min, max, keyCode = "" }: FormMinMaxInterface) => {
    const [activeCategory, setActiveCategory] = useState({
        isMin: !!min.initialValue,
        isMax: !!max.initialValue,
    })

    return (
        <Collapse ghost defaultActiveKey={keyCode} className={activeCategory.isMin || activeCategory.isMax ? "filter--active" : ""}>
            <Collapse.Panel header={header} key={keyCode} forceRender>
                <Row gutter={[16, 16]}>
                    <FormInputElem
                        elem={{ ...min, inputType }}
                        normalize={normalize}
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                        category={FormCategoryEnum.MIN}
                    />
                    <FormInputElem
                        elem={{ ...max, inputType }}
                        normalize={normalize}
                        activeCategory={activeCategory}
                        setActiveCategory={setActiveCategory}
                        category={FormCategoryEnum.MAX}
                    />
                </Row>
            </Collapse.Panel>
        </Collapse>
    )
}

// TODO get rid of default export
export default FormMinMax
